import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Label } from "../VersionTab/types";

import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { useCreateABtest } from "@/queries";
import { displayErrorToast } from "@/utils/toast";

const useABTestManagement = () => {
  const activeWorkspaceId = useUser()?.activeWorkspaceId;
  const userToken = useAuth()?.userToken;
  const createABtest = useCreateABtest(userToken!);
  const navigate = useNavigate();
  const [versionIdForABTest, setVersionIdForABTest] = useState<number | null>(null);
  const [labelsSelectOpen, setLabelsSelectOpen] = useState(false);

  const handleABTestButtonClick = (
    promptId: number,
    promptVersionId: number,
    allLabels: Label[],
  ) => {
    if (allLabels.length === 0) {
      createABtest.mutate(
        {
          promptId,
          promptVersionId,
          workspaceId: activeWorkspaceId!,
        },
        {
          onSuccess: res => {
            if (res?.success && res?.release_label_group?.id) {
              navigate(
                `/workspace/${activeWorkspaceId}/ab-releases/prompt-release-group/${res?.release_label_group?.id}?prompt=${promptId}`,
              );
            } else {
              displayErrorToast(res?.message ?? "There's a problem with the AB Test request");
            }
          },
          onError: () => {
            displayErrorToast("There's a problem with the AB Test request");
          },
        },
      );

      return;
    }

    setVersionIdForABTest(promptVersionId);
    setLabelsSelectOpen(true);
  };

  return {
    versionIdForABTest,
    labelsSelectOpen,
    setLabelsSelectOpen,
    handleABTestButtonClick,
  };
};

export default useABTestManagement;
